
import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { HexColorPicker } from 'react-colorful';
import { ColorsType } from '../../../DandDPalette';

import SelectStringBox from "@components/input/selects/SelectStringBox";
import ExpandButton from "@components/input/buttons/ExpandButton";
import DandDButtonBox from "@dndComponents/DandDButtonBox";
import ImageFromString from "@dndComponents/display/ImageFromString";
import StringBox from "@components/input/strings/StringBox";

interface Props { 
  colors: ColorsType;
  onChange: (changed: ColorsType) => void;
}

export default function ColorsBox({ 
  colors,
  onChange,
}: Props) {
  const [ping, setPing] = useState(false);

  const backgroundColor = colors.backgroundColor+"80";
  const color = colors.color === "Default" ? undefined : colors.color;
    
  return (
    <Grid container spacing={0} direction="row" className="dracoLich">
      <Grid
        size={{
          xs: 3
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            className="header centered"
            size={{
              xs: 12
            }}>
            Background Color
          </Grid>
          <Grid
            className="centered"
            size={{
              xs: 12
            }}>
            <HexColorPicker
              color={colors.backgroundColor}
              onChange={(changed: string) => {
                onChange({ backgroundColor: changed, color: colors.color });
                setPing(!ping);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox
              name=""
              value={colors.backgroundColor}
              onChange={(changed: string) => {
                onChange({ backgroundColor: changed, color: colors.color });
                setPing(!ping);
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <SelectStringBox
          name="Text and Border Color"
          options={["Default","Black","White"]}
          value={colors.color}
          onChange={(changed: string) => {
            onChange({ backgroundColor: colors.backgroundColor, color: changed });
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        className="padded"
        size={{
          xs: 6
        }}>
        <Grid container spacing={0} direction="row" style={{ backgroundColor, color, fontSize: "11px" }}>
          <Grid
            size={{
              xs: 2
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                className="centered"
                size={{
                  xs: 12
                }}>
                <span>Sample&nbsp;<span style={{ backgroundColor: "black", color: "white", fontSize: "8px" }}>C</span>&nbsp;<span style={{ backgroundColor: "black", color: "white", fontSize: "8px" }}>V S M</span></span>
              </Grid>
              <Grid
                className="centered small_label"
                size={{
                  xs: 12
                }}>
                Source
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={0}
            direction="row"
            size={{
              xs: 1
            }}>
            <Grid
              size={{
                xs: 6
              }}>
              <ExpandButton is_expanded={false} onClick={() =>{ }} />
            </Grid>
          </Grid>
          <Grid
            size={{
              xs: 9
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>
                  <Grid container spacing={0} direction="row">
                    <Grid
                      size={{
                        xs: 12
                      }}>
                      <DandDButtonBox name="Cast" onClick={() => {}} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 9
                  }}>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <Grid container spacing={0} direction="row" style={{ minHeight: "37.5px"}}>
                      <Grid
                        className="centered"
                        size={{
                          xs: 4
                        }}>
                        120 ft.
                      </Grid>
                      <Grid
                        className="centered"
                        size={{
                          xs: 4
                        }}>
                        <DandDButtonBox name="+8" onClick={() => {}} />
                      </Grid>
                      <Grid
                        className="centered"
                        size={{
                          xs: 4
                        }}>
                        <Grid container spacing={0} direction="row">
                          <Grid
                            size={{
                              xs: 12
                            }}>
                            <DandDButtonBox
                              name="8d6"
                              style={{ fontSize: "9" }}
                              image={ "Fire" }
                              onClick={() => { }} 
                            />
                          </Grid>
                          <Grid
                            size={{
                              xs: 12
                            }}>
                            <span><ImageFromString image="Fire" />&nbsp;</span>
                            <span><ImageFromString image="Lightning" />&nbsp;</span>
                            <span><ImageFromString image="Cold" />&nbsp;</span>
                            <span><ImageFromString image="Psychic" />&nbsp;</span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
